<template>
  <!-- div#body:start -->
  <div id="body" :class="{'is-visible-menu-left':documentLogic.state.visibleMenuLeft}">
    <BackgroundImage />

    <!-- 左ナビ -->
    <div id="menu-left" class="menu-left">
      <ul class="menu-left-list">
        <li class="menu-left-list-item" @click="openDetail">
          <span class="menu-left-list-item-label"
          >ページを別ウインドウで開く</span>
        </li>
        <li class="menu-left-list-item" @click="documentLogic.state.visibleNoteSelect = true">
          <span class="menu-left-list-item-label">
            ノートに保存する
          </span>
        </li>
      </ul>
      <div class="menu-left-close"
        @click="documentLogic.state.visibleMenuLeft = false"
      >
        <span class="icn-wrap"><FontawesomeIcon :icon="['fal', 'times']" class="icn" /></span>
      </div>
    </div>

    <!-- ノート選択 -->
    <transition name="popup">
      <SPNoteSelect
        v-if="documentLogic.state.visibleNoteSelect"
        :type="'pj'"
        :pageId="documentLogic.state.detailId"
        :title="documentLogic.state.detailName"
        @openCreateNote="documentLogic.state.visibleNoteCreate = true"
        @closeSelectNote="documentLogic.state.visibleNoteSelect = false"
      />
    </transition>
    <!-- ノート作成 -->
    <transition name="popup">
      <SPNoteCreate
        v-if="documentLogic.state.visibleNoteCreate"
        :type="'pj'"
        :pageId="documentLogic.state.detailId"
        :title="documentLogic.state.detailName"
        @closeCreateNote="documentLogic.state.visibleNoteCreate = false"
      />
    </transition>

    <div id="wrapper">
      <!-- div#header:start -->
      <SPDocumentMenu
        :bookName="documentLogic.state.bookName"
        :booksArray="documentLogic.state.books"
        :currentIndex="documentLogic.state.tab" 
        :showBookmark="documentLogic.state.isShowDetail"
        :isBookmark="documentLogic.data.detail.bookmarks_id !==0"
        @clickBookmark="documentLogic.clickBookmark"
        @changeBook="logic.selectBook"
      />

      <div id="menu-btn" class="menu-btn">
        <!-- 目次表示ボタン -->
        <div role="button" class="menu-btn-1"
          style="width:82px;height:72px;"
          v-show="documentLogic.state.isShowResult || documentLogic.state.isShowDetail"
          @click="operationSizeChange.showSummary"
          @touchstart="onTapStart($event.target)"
          @touchend="onTapEnd($event.target)"
        >
          <span class="icn" style="width: 24px; height: 24px;">
            <IcnList2 />
          </span>
        </div>
        <!-- 一覧表示ボタン -->
        <div role="button" class="menu-btn-2"
          style="width:82px;height:72px;"
          v-show="documentLogic.state.isShowDetail"
          @click="operationSizeChange.showList"
          @touchstart="onTapStart($event.target)"
          @touchend="onTapEnd($event.target)"
        >
          <span class="icn icn-file" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
            <FontawesomeIcon :icon="['far','angle-left']" size="2x" />
          </span>
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        v-show="documentLogic.state.isShowDetail"
        @click="documentLogic.state.visibleMenuLeft = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-container" id="scroll-area" ref="scrollArea">
            <!-- contents -->
            <div class="document-lists" v-if="!documentLogic.state.isShowResult && !documentLogic.state.isShowDetail">
              <FontawesomeIcon v-if="documentLogic.state.isTocLoading" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>
                <p class="document-lists-title">{{documentLogic.state.bookName}}</p>
                <PCDocumentPartAccordion
                  v-if="precedentData.toc"
                  ref="accordionRef"
                  :items="precedentData.toc"
                  @changeTheme="logic.changeThemeURL"
                />
              </template>
            </div>

            <div class="document-result" v-if="documentLogic.state.isShowResult && !documentLogic.state.isShowDetail">
              <p class="document-result-title" v-html="documentLogic.state.themeName"></p>
              <div class="document-result-body">
                <FontawesomeIcon v-if="documentLogic.state.isListLoading || documentLogic.state.isMasterLoading" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                  <template v-else>
                    <PCDocumentPartResultItem
                      v-for="(item, i) in documentLogic.data.list"
                      :key="item.id"
                      :item="item"
                      @detailClick="documentLogic.showDetail.open"
                      @openRelated="documentLogic.showDetail.openRelated(i)"
                      @openReference="documentLogic.showDetail.openReference(i)"
                    />
                  </template>
              </div>
            </div>
            <div class="document-detail" v-if="documentLogic.state.isShowDetail">
              <PCDocumentPartDetail
                :item="documentLogic.data.detail"
                :isLoading="documentLogic.state.isDetailLoading || documentLogic.state.isMasterLoading"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import SPSearchUI from '@/components/sp/partial/SPSearchUI.vue'
import SPDocumentMenu from '@/components/sp/partial/SPDocumentMenu.vue'
import SPQASearchDetail from '@/components/sp/popup/SPQASearchDetail.vue'
import SPBookSearchExtract from '@/components/sp/popup/SPBookSearchExtract.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'
import PCDocumentPartDetail from '@/components/pc/partial/document/PCDocumentPartDetail.vue'
import PCDocumentPartResultItem from '@/components/pc/partial/document/PCDocumentPartResultItem.vue'
import PCDocumentPartAccordion from '@/components/pc/partial/document/PCDocumentPartAccordion.vue'
import SPNoteSelect from '@/components/sp/popup/SPNoteSelect.vue'
import SPNoteCreate from '@/components/sp/popup/SPNoteCreate.vue'

import { DocumentList } from '@/logic/document/DocumentList'
import { openPrecedentDetail } from '@/logic/common/CommonPrecedent'

export default defineComponent({
  props: {
    // 先例・判例詳細ID：URLで渡された値(/routes/index.jsで定義)
    detailId: {
      type: Number,
      default: 0
    },
    // 先例・判例詳細ID：URLで渡された値(/routes/index.jsで定義)
    themeId: {
      type: Number,
      default: 0
    },
    bookRevisionId: {
      type: Number,
      default: 0
    }
  },
  components: {
    SPSearchUI,
    SPDocumentMenu,
    SPQASearchDetail,
    SPBookSearchExtract,
    SPBasicToast,
    PCDocumentPartDetail,
    PCDocumentPartResultItem,
    PCDocumentPartAccordion,
    SPNoteSelect,
    SPNoteCreate
  },
  setup (props, context) {
    const openDetail = () => {
      openPrecedentDetail(props.detailId)
    }

    const onTapStart = (target) => {
      target.style.backgroundColor = '#D4E7F4'
    }

    const onTapEnd = (target) => {
      target.style.backgroundColor = ''
    }

    return {
      openDetail,
      onTapStart,
      onTapEnd,
      ...DocumentList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading {
    &-bookinfo {
      padding: 20px;
      background-color: $color-bg-paper;
      &-title {
        color: $color-sup;
        font-size: 1.2rem;
      }
    }
  }
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height);
    &.is-1-main-heading-shown {
      @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    }
    &.is-2-main-heading-shown {
      @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height * 2);
    }
    .hdg04 {
      padding: 20px;
      margin-bottom: 0;
      border-bottom: 1px solid $color-line;
    }
  }
}
.menu-btn {
  &-1 {
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }

  &-1,
  &-2 {
    &:active {
      background-color: #D4E7F4;
    }
  }
}

.is-visible-serach-settings {
  .menu-btn {
    // transform: translate3d(0,-128px,0);
    transform: translate3d(0,-271px,0);
    &-1 {
      .icn {
        transition: all .2s ease;
      }
      .icn-opened {
        opacity: 1;
      }
      .icn-closed {
        opacity: 0;
      }
    }
  }
  .search-settings {
    transform: translate3d(0,0,0);
    box-shadow: 0 -8px 8px rgba(0,0,0,.16);
  }
}

.pagenation {
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid $color-line;
  border-radius: 6px;
  &-wrp {
    background-color: $color-bg-paper;
    padding: 20px 20px 100px;
    &.is-open {
      padding-bottom: 330px;
    }
  }
  &-link {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-link;
    font-size: 1.4rem;
    height: 48px;
    flex: 0 1 50%;
    .icn {
      margin: 0 5px;
    }
    &.first,&.prev {
      border-right: 1px solid $color-line;
    }
    &.last,&.next {
      border-left: 1px solid $color-line;
    }
  }
}

</style>
